import CityPageTemplate from "../city-template/CityPageTemplate";
import { arlingtonVaConfig } from "./data";

export default function ArlingtonVaPage() {
  return <CityPageTemplate config={arlingtonVaConfig} />;
}